import styled from "styled-components";
import pixelToRem from "../../utils/pxToRem";

import { ButtonProps } from ".";

export const ButtonComponent = styled.button<ButtonProps>`
  background: var(--cta-green);
  width: ${({ fullWidth }) => (fullWidth ? "100%" : pixelToRem(200))};
  height: ${pixelToRem(60)};
  border: none;
  border-radius: ${pixelToRem(10)};
  color: var(--text-primary);
  font: var(--text-3);
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${pixelToRem(8)};
  box-shadow: 0 8px 20px rgba(17, 17, 17, 0.28);


  svg {
    width: 30px;
    height: 30px;
  }

  &:hover {
    cursor: pointer;
    background: var(--cta-green-hover);
    transform: translateY(-2px);
    box-shadow: 0 14px 24px rgba(22, 163, 74, 0.24);
  }
`;
